import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter();

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/synonymsroleslink/';
    const paths = {
        endpointSave: config.endpoints.backend + 'rolesentityemployees/savelink',
        endpointGetById: config.endpoints.backend + 'rolesentityemployees/getById',
        endpointGetAllSynonyms: config.endpoints.backend + 'cbosynonyms/getall',
        endpointGetAllRoles: config.endpoints.backend + 'rolesentityemployees/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Vínculo",
        labelTitleEdit: "Editar Vínculo",
        labelTitleView: 'Visualizar Vínculo'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'id',
                    type: 'select',
                    label: 'Cargo - Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllRoles,
                        label: 'role',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    disabled: !!id,
                    readonly: !!id,
                    columnSize: 12
                },
                {
                    name: 'pdc_cbo_synonymous_id',
                    type: 'select',
                    label: 'Sinônimo CBO',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllSynonyms,
                        label: 'title',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
